export default {
  ID: 'NEW_REQUEST',
  PATH: '/new-request',
  SIDEBAR_IMAGE: true,
  FOOTER: true,
  BUTTON_HELP: true,
  BUTTON_LANG: true,
};
